export const TYPE_LABELS = {
    user: "Пользователи",
    partner: "Партнёры",
    offer: "Офферы",
    global_entity: "Сайты / бренды",
    campaign: "Кампании",
    segment: "Сегменты",
    provider: "Провайдеры",
    page: "Страницы",
    creo_job: "Креативы",
    event: "События",
};
//# sourceMappingURL=types.js.map